// extracted by mini-css-extract-plugin
export default {"melodyVideo":"bK-z","isFullWidth":"cK-z","landingPageVideo":"dK-z","play":"eK-z","iframeVideo":"fK-z","playHidden":"gK-z","fullwidth":"hK-z"};